// all the currencies needed
const Currencies = [
    { code: 'AUD', symbol: 'A$', name: 'Australian dollar' },
    { code: 'BRL', symbol: 'R$', name: 'Brazilian real' },
    { code: 'CAD', symbol: 'C$', name: 'Canadian dollar' },
    { code: 'CNY', symbol: '元', name: 'Chinese renminbi' },
    { code: 'EUR', symbol: '€', name: 'Euro' },
    { code: 'HKD', symbol: 'HK$', name: 'Hong Kong dollar' },
    { code: 'INR', symbol: '₹', name: 'Indian rupee' },
    { code: 'JPY', symbol: '¥', name: 'Japanese yen' },
    { code: 'MXN', symbol: '$', name: 'Mexican peso' },
    { code: 'NZD', symbol: 'NZ$', name: 'New Zealand dollar' },
    { code: 'NOK', symbol: 'kr', name: 'Norwegian krone' },
    { code: 'GBP', symbol: '£', name: 'Pound sterling' },
    { code: 'RUB', symbol: '₽', name: 'Russian ruble' },
    { code: 'SGD', symbol: 'S$', name: 'Singapore dollar' },
    { code: 'KRW', symbol: '₩', name: 'South Korean won' },
    { code: 'SEK', symbol: 'kr', name: 'Swedish krona' },
    { code: 'CHF', symbol: 'CHF', name: 'Swiss franc' },
    { code: 'THB', symbol: '฿', name: 'Thai baht' },
    { code: 'USD', symbol: '$', name: 'United States dollar' },
    { code: 'PLN', symbol: 'zł', name: 'Polish zloty' },
    // Special value(s)
    { code: 'PER', symbol: '%', name: 'Percentage' }
];

export default Currencies;
